import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentWizard = _resolveComponent("DocumentWizard")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    persistent: "",
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
    "max-width": !_ctx.$vuetify.display.mobile ? '900px' : undefined,
    fullscreen: _ctx.$vuetify.display.mobile,
    "hide-overlay": _ctx.$vuetify.display.mobile,
    title: _ctx.title,
    actions: _ctx.actions,
    "previous-display": !_ctx.disabledPrevious(),
    onPrevious: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previous())),
    prefixDataCy: "DocumentWizardDialog-valid",
    "min-width": "60vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_DocumentWizard, {
        ref: "documentWizard",
        companyId: _ctx.companyId,
        documentId: _ctx.documentId,
        documentType: _ctx.documentType,
        amount: _ctx.amount,
        multiple: _ctx.multiple,
        showFirstPrevious: _ctx.showFirstPrevious,
        inGlobalStep: _ctx.inGlobalStep,
        inExtensions: _ctx.inExtensions,
        openCameraOnly: _ctx.openCameraOnly,
        dialog: true,
        actions: _ctx.actions,
        ownerId: _ctx.ownerId,
        onFilesUploaded: _ctx.onFilesUploaded,
        onStartMiscellaneousOperation: _ctx.onStartMiscellaneousOperation,
        onStartMiscellaneous: _ctx.onStartMiscellaneous,
        onStartLoanOcr: _ctx.onStartLoanOcr,
        onBack: _ctx.onBack,
        onCreated: _ctx.onCreated,
        onNewDocument: _ctx.onNewDocument,
        onInsideDocumentType: _ctx.onInsideDocumentTypeChanged,
        onGlobalStep: _ctx.onGlobalStepChanged,
        onWizardStep: _ctx.onWizardStepChanged,
        onInvoiceType: _ctx.onInvoiceTypeChanged,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog())),
        class: "w-100",
        style: _normalizeStyle({ minHeight: _ctx.$vuetify.display.mobile ? '60vh' : '' })
      }, null, 8, ["companyId", "documentId", "documentType", "amount", "multiple", "showFirstPrevious", "inGlobalStep", "inExtensions", "openCameraOnly", "actions", "ownerId", "onFilesUploaded", "onStartMiscellaneousOperation", "onStartMiscellaneous", "onStartLoanOcr", "onBack", "onCreated", "onNewDocument", "onInsideDocumentType", "onGlobalStep", "onWizardStep", "onInvoiceType", "style"])
    ]),
    _: 1
  }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay", "title", "actions", "previous-display"]))
}